import React from 'react';
import { observer } from 'mobx-react';
import { MemberList } from '../components/Team/MemberList';
export var TeamPage = observer(function (props) {
    var client = props.client;
    return React.createElement(MemberList, { client: client });
});
export default TeamPage;
